export const getPlaceType = (isHeaderButton: boolean) =>
  isHeaderButton ? 'Open_jk_card_blockStickytop' : 'Open_jk_card_blockJK';
